/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { Table } from '@components/design-system';
import {
  UserComponent,
  DateComponent,
  PriceComponent,
  ActionAuctionsComponent,
  TextComponent,
} from '@components/table-components';
import { MutToTez } from '@utils/format';

const settings = [
  // {
  //   key: 'status',
  //   label: 'Status',
  //   Component: ({ status }: Record<string, any>) => <TextComponent value={status} />,
  // },
  {
    key: 'sellerScreenName',
    label: 'Seller',
    Component: ({ sellerScreenName, seller, sellerIsYou, sellerIsCreator }: Record<string, any>) => (
      <UserComponent
        {...seller.user[0].user}
        parsedScreenName={sellerScreenName}
        address={seller.address}
        isYou={sellerIsYou}
        isCreator={sellerIsCreator}
      />
    ),
  },
  {
    key: 'start_time',
    label: 'Auction start',
    Component: ({ start_time }: Record<string, any>) => {
      return <DateComponent timestamp={start_time} />;
    },
  },
  {
    key: 'end_time',
    label: 'Auction end',
    Component: ({ end_time }: Record<string, any>) => {
      return <DateComponent timestamp={end_time} />;
    },
  },
  {
    key: 'current_bidder',
    label: 'Highest Bidder',
    Component: ({ bidderScreenName, current_bidder, bidderIsYou, bidderIsCreator }: Record<string, any>) => {
      if (current_bidder) {
        return (
          <UserComponent
            {...current_bidder.user[0].user}
            parsedScreenName={bidderScreenName}
            address={current_bidder.user[0].user.id}
            isYou={bidderIsYou}
            isCreator={bidderIsCreator}
          />
        );
      }
      return null;
    },
  },
  {
    key: 'current_bid',
    label: 'Highest Bid',
    Component: ({ current_bid, current_bidder }: Record<string, any>) => {
      const hasBidder = current_bidder?.user[0].user;
      return hasBidder ? <PriceComponent value={MutToTez(current_bid)} /> : <TextComponent value="No bids" />;
    },
  },
  {
    key: 'actions',
    label: 'Actions',
    Component: (props: any) => <ActionAuctionsComponent {...props} />,
  },
];

interface ITableTokenAuctions {
  data: any[];
}

export const TableTokenAuctions: FC<ITableTokenAuctions> = ({ data }) => {
  return <Table settings={settings} data={data} />;
};
